




















































import Vue from 'vue';
import SocialSecurityNumberInputComponent from '@/components/form/SocialSecurityNumberInputComponent.vue';
import { ExtraditionRecipientOverride } from '@/interfaces/keepsake/extraditionRecipientOverride';

export default Vue.extend({
  components: { SocialSecurityNumberInputComponent },
  props: {
    value: Boolean,
    recipientOverride: Object as () => ExtraditionRecipientOverride | null,
  },
  data() {
    return {
      name: '',
      ssn: '',
      formValid: false,
      requiredRules: [
        v => !!v || 'Obligatoriskt fält',
      ],
    };
  },
  computed: {
    active: {
      get(): Boolean {
        return this.value;
      },
      set(value: Boolean) {
        this.$emit('update:value', value);
      },
    },
    eitherFilled(): boolean {
      return !!this.name || !!this.ssn;
    },
  },
  watch: {
    active(value: boolean) {
      if (value) {
        this.name = this.recipientOverride ? this.recipientOverride.name : '';
        this.ssn = this.recipientOverride ? this.recipientOverride.ssn : '';
        this.$nextTick(() => {
          this.$refs.recipientForm.resetValidation();
        });
      }
    },
  },
  methods: {
    closeDialog() {
      this.active = false;
    },
    fetchAgreement() {
      if (this.$refs.recipientForm.validate()) {
        let recipientOverride: ExtraditionRecipientOverride | null = this.eitherFilled ? {
          name: this.name,
          ssn: this.ssn,
        } : null;
        this.$emit('update:recipientOverride', recipientOverride);
        this.closeDialog();
      }
    },
  },
});
